import {
  Component,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { Notification } from '../../models/core.models';

import { loadLatestNotifications } from '../../actions/auth.actions';

import {
  selectAuthUserNotifications,
  selectAuthUserNotificationsLoaded,
  selectAuthUserNotificationsLoading,
} from '../../reducers';
import { AppState } from 'src/app/reducers';

import { Observable, take, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationsComponent {
  notifications$: Observable<Notification[]>;
  notificationsLoading$: Observable<boolean>;

  private destroyRef = inject(DestroyRef);

  constructor(private store: Store<AppState>) {
    this.store
      .select(selectAuthUserNotificationsLoaded)
      .pipe(
        take(1),
        tap((loaded) => {
          if (!loaded) {
            this.store.dispatch(loadLatestNotifications());
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();

    this.notifications$ = this.store.select(selectAuthUserNotifications);
    this.notificationsLoading$ = this.store.select(
      selectAuthUserNotificationsLoading,
    );
  }
}
